import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import api from "../lib/api";
import { toast } from "sonner";

/**
 * Handles the Emergent Google OAuth redirect.
 * URL pattern after Google sign-in: /#session_id=<value>
 * We POST it to /api/auth/oauth/session, store the returned JWT, and refresh the auth context.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkSession } = useAuth();

  useEffect(() => {
    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        navigate("/login", { replace: true });
        return;
      }
      const sessionId = decodeURIComponent(match[1]);
      // Strip the hash so it can't be reused on refresh
      window.history.replaceState(null, "", window.location.pathname);
      try {
        const { data } = await api.post("/auth/oauth/session", { session_id: sessionId });
        if (data?.access_token) localStorage.setItem("flowtasks_access_token", data.access_token);
        if (data?.refresh_token) localStorage.setItem("flowtasks_refresh_token", data.refresh_token);
        await checkSession();
        toast.success(data?.is_new ? "Account created — welcome!" : "Welcome back");
        navigate("/personal", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      }
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-sm text-muted-foreground font-mono" data-testid="auth-callback-loading">
        Completing sign-in…
      </div>
    </div>
  );
}
